import { AvailableUserForTransfer, XmppSessionType, MessageModel, OpenFireChatType, MessageType } from "../models";
import { signalRChatService } from "./SignalRChatService";
import { xmppChatService } from "./XmppChatService";
import { ChatModel, TestingChatModule } from "../models/index";
import { IChatService } from "./IChatService";

class ChatService {
    AutoReconnect: boolean = true;
    services: Map<string, IChatService> = new Map<string, IChatService>();

    async connect(type: XmppSessionType) {

        this.services = new Map<string, IChatService>([
            [OpenFireChatType, xmppChatService],
            ["Chat", xmppChatService],
            ["web2.0", signalRChatService],
            ["TextUs", signalRChatService],
            ["facebook", signalRChatService],
            ["facebookBot", signalRChatService],
            ["HybridFaceBookChat", signalRChatService],
            ["RTC", signalRChatService],
            ["WhatsApp", signalRChatService],
            ["WhatsAppBot", signalRChatService],
            ["Hybrid Whats App Chat", signalRChatService],
            ["AI Open Bot", signalRChatService],
            ["TextUsGMB", signalRChatService],
        ]);

        this.AutoReconnect = true;

        if (!xmppChatService.isConnected()) {
            await xmppChatService.connect(type);
        }

        if (!signalRChatService.isConnected()) {
            await signalRChatService.connect();
        }
    }

    getChatType = (chatType) => {
        if (chatType == "Chat") {
            return xmppChatService
        }

        return signalRChatService
    }
    // testingSendMessage = (chat:TestingChatModule , messageBody: string,) => {
    //     this.getChatType(chat.info.chatType)!.sendDefaultMessage(chat, messageBody);
    // }
    sendMessage = (chat: ChatModel, messageBody: string, takenOver: boolean, userId: string, messageType: MessageType, chatSize: number, TextToSpeech?: boolean) => {
        this.getChatType(chat.info.chatType)!.sendMessage(chat, messageBody, takenOver, userId, messageType, chatSize, TextToSpeech);
    };

    sendMessageForBotChatGeneric = (chat: ChatModel, messageBody: string, takenOver: boolean, userId: string, messageType: MessageType, chatSize: number) => {
        signalRChatService.sendMessageForBotChatGeneric(chat, messageBody, takenOver, userId, messageType, chatSize);
    };

    reAttachExistingRoom = async (chat: ChatModel) => {
        this.checkChatType(chat.info.chatType);
        await this.getChatType(chat.info.chatType)!.reAttachExistingRoom(chat);
        await signalRChatService.attachEvents(chat.info.chatId, chat.info.websiteId, chat.info.visitorId, chat);
    };

    dndChat = async (chatType: string, roomId: string, websiteId: string, visitorId: string, chatId: string) => {
        this.checkChatType(chatType);
        this.getChatType(chatType)!.dndChat(chatType, roomId, websiteId, visitorId, chatId);
    };

    blockChat = async (chatType: string, roomId: string, websiteId: string, visitorId: string, chatId: string) => {
        this.checkChatType(chatType);
        this.getChatType(chatType)!.blockChat(chatType, roomId, websiteId, visitorId, chatId);
    };

    transferChatOperator = (chatInfo: MessageModel, targetOperator: AvailableUserForTransfer, isAutoTransfer: boolean) => {
        this.checkChatType(chatInfo.chatType);
        this.getChatType(chatInfo.chatType)!.transferChat(chatInfo, targetOperator, isAutoTransfer);
    };

    updateNickName(chatInfo: MessageModel, newName: string) {
        this.checkChatType(chatInfo.chatType);
        this.getChatType(chatInfo.chatType)!.updateNickName(chatInfo.chatType, chatInfo.chatId, parseInt(chatInfo.websiteId), chatInfo.visitorId, newName);
    }

    async disconnect() {
        this.AutoReconnect = false;

        await signalRChatService.disconnect();
        await xmppChatService.disconnect();
    }

    checkChatType(chatType: string) {
        if (!this.services.has(chatType)) {
            // console.error(`Unknown Chat Type: '${chatType}'`);
        }
    }

    buzzQC = (buzzType: string, chat: ChatModel, messageBody: string) => {
        this.getChatType(chat.info.chatType)!.buzzQC(buzzType, chat, messageBody);
    };

    QCMessageByCannedKeyword = async (message: string, chatType: string, roomId: string, websiteId: string, visitorId: string, chat_id: string, VisitorName: string) => {
        this.getChatType(chatType)!.QCMessageByCannedKeyword(message, chatType, roomId, websiteId, visitorId, chat_id, VisitorName);
    }

    isConnected = (): boolean => {
        return xmppChatService.isConnected() && signalRChatService.isConnected();
    };

    sendGreeterMsgAsQC = (msg: string, chatId: string, websiteId: Number, visitorName: string, chatType: string, chat?: ChatModel) => {
        this.getChatType(chatType)!.sendGreeterMsgAsQC(msg, chatId, websiteId, visitorName, chat);
    };

    sendInitVideoMsg = (msg: string, chatType: string, chat?: ChatModel) => {
        this.getChatType(chatType)!.sendInitVideoMsg(msg, chat);
    };

    leaveRoom = (chatId: string, chatType: string) => {
        this.getChatType(chatType)!.leaveRoom(chatId);
    };

    transferChatByQc = (chatInfo: MessageModel, targetOperator: AvailableUserForTransfer, isAutoTransfer: boolean, chatType: string, domainName) => {
        this.getChatType(chatType)!.transferChatByQc(chatInfo, targetOperator, isAutoTransfer, chatType, domainName);
    }

}

var chatService = new ChatService();
export { chatService };
